import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  text: {
    textAlign: "center",
  },
};
